/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { APP_INITIALIZER, NgModule } from '@angular/core';
import {OAuthModule, OAuthService, OAuthStorage, OAuthLogger, ValidationHandler, NullValidationHandler, OAuthResourceServerErrorHandler, OAuthNoopResourceServerErrorHandler, OAuthModuleConfig, UrlHelperService} from 'angular-oauth2-oidc';
import { HashHandler, DefaultHashHandler, DateTimeProvider, SystemDateTimeProvider } from 'angular-oauth2-oidc';
import { AuthenticationService } from './authentication.service';


export function initAuth(authenticationService: AuthenticationService, oauthService: OAuthService): () => void {

    return () => new Promise<void>((resolve) => {
        // Check if the user is already authenticated
        if (authenticationService.isAuthenticated()) {
          const claims = authenticationService.userInfo;
          sessionStorage.setItem('gmin',claims.gmin)
          sessionStorage.isSiteAdmin = claims.roles.indexOf("PGA_SiteAdmin") >= 0;
          sessionStorage.isSuperAdmin = claims.roles.indexOf("PGA_Admin") >= 0;
          sessionStorage.siteAdminRoles = claims.roles.filter(x=>!x.indexOf("PGA_SiteAdmin_"));
          resolve();
        } else {
          // If not, try to authenticate the user
          authenticationService.initialize().then((isAuthenticated: boolean) => {
            if (isAuthenticated) {
              const claims = authenticationService.userInfo;
              sessionStorage.setItem('gmin',claims.gmin)
              sessionStorage.isSiteAdmin = claims.roles.indexOf("PGA_SiteAdmin") >= 0;
              sessionStorage.isSuperAdmin = claims.roles.indexOf("PGA_Admin") >= 0;
              sessionStorage.siteAdminRoles = claims.roles.filter(x=>!x.indexOf("PGA_SiteAdmin_"));
            }
            // Always resolve so APP_INITIALIZER does not hang.
            // AuthGuard will handle unauthenticated users.
            resolve();
          }).catch(() => resolve());
        }
      });
}

@NgModule({
    imports: [OAuthModule],
    providers: [
        OAuthService,
        UrlHelperService,
        { provide: OAuthLogger, useFactory: () => console },
        { provide: OAuthStorage, useFactory: () => sessionStorage },
        { provide: ValidationHandler, useClass: NullValidationHandler },
        { provide: HashHandler, useClass: DefaultHashHandler },
        { provide: OAuthResourceServerErrorHandler, useClass: OAuthNoopResourceServerErrorHandler },
        { provide: OAuthModuleConfig, useValue: null },
        { provide: DateTimeProvider, useClass: SystemDateTimeProvider },
        AuthenticationService,
        {
            provide: APP_INITIALIZER,
            useFactory: initAuth,
            deps: [AuthenticationService],
            multi: true,
        },
    ],
})
export class AuthenticationModule {
}
